import CustomMarker from './CustomMarker'
import CustomMapTooltip from "./CustomMapTooltip";
import {
  Polygon,
  Polyline,
  Popup,
  Tooltip
} from "react-leaflet";
import _ from "lodash";

function POIFilter(props) {
  const { data } = props
  return (
    <div>
      {/* POI Filter Secton */}
      {data !== "" && data !== undefined
        ? data.map((item, index) => {
          if (item.poiTypeId === 1) {
            // Marker Geofence
            var val = item.geomText;
            var point_latlon = val.split(" ");
            var lat = point_latlon[1];
            var lon = point_latlon[0];
            return (
              <CustomMarker position={[point_latlon[1], point_latlon[0]]} item={item} lat={lat} lon={lon} />
            );
          } else if (item.poiTypeId === 2) {
            const geomTextvalue = _.toString(item.geomText).split(
              ","
            );
            var polyline_position = [];
            var polyline_positions = geomTextvalue.map((item) => {
              const split_pos = item.split(" ");
              return split_pos;
            });
            polyline_positions.map((item) => {
              _.toString(item.reverse());
              polyline_position.push(item);
            });
            return (
              <Polyline
                positions={polyline_position}
                onMouseOver={(e) => {
                  e.target.openPopup();
                }}
                onMouseOut={(e) => {
                  e.target.closePopup();
                }}
              >
                <Tooltip
                  direction="top"
                  offset={[0, -10]}
                  className="custom-tooltip"
                  
                >
                  <span>{item.poiName}</span>
                </Tooltip>
                <Popup>
                  <CustomMapTooltip
                    poiname={item.poiName}
                    poicode={item.poiCode}
                    poigroup={item.poiGroupName}
                  />
                </Popup>
              </Polyline>
            );
          } else if (item.poiTypeId === 3) {
            const geomTextvalue = _.toString(item.geomText).split(
              ","
            );
            var polygon_position = [];
            var polygon_positions = geomTextvalue.map((item) => {
              const split_pos = item.split(" ");
              return split_pos;
            });
            polygon_positions.map((item) => {
              _.toString(item.reverse());
              polygon_position.push(item);
            });
            return (
              <Polygon
                positions={polygon_position}
                onMouseOver={(e) => {
                  e.target.openPopup();
                }}
                onMouseOut={(e) => {
                  e.target.closePopup();
                }}

              >
                 <Tooltip
                  direction="top"
                  offset={[0, -10]}
                  className="custom-tooltip"
                  
                >
                  <span>{item.poiName}</span>
                </Tooltip>
                <Popup>
                  <CustomMapTooltip
                    poiname={item.poiName}
                    poicode={item.poiCode}
                    poigroup={item.poiGroupName}
                  />
                </Popup>
              </Polygon>
            );
          }
        })
        : ""}
      {/* POI Filter Secton */}
    </div>
  )
}
export default POIFilter;